/** Helpers for Sweden snus product detail routes and formatting. */

export const SNUS_PROJECT_KEY = 'sweden-snus-admin';
export const SNUS_ACCENT = '#1565c0';

export function encodeSnusSkuKey(skuKey) {
  return encodeURIComponent(skuKey || '');
}

export function decodeSnusSkuKey(encoded) {
  try {
    return decodeURIComponent(encoded || '');
  } catch {
    return encoded || '';
  }
}

export function buildSnusProductDetailPath(
  skuKey,
  { country = 'Sweden', brand = '', category = '', week = '', retailerTable = '' } = {}
) {
  const params = new URLSearchParams();
  if (country) params.set('country', country);
  if (brand) params.set('brand', brand);
  if (category) params.set('category', category);
  if (week) params.set('week', week);
  if (retailerTable) params.set('retailer_table', retailerTable);
  const qs = params.toString();
  return `/${SNUS_PROJECT_KEY}/snus-product/${encodeSnusSkuKey(skuKey)}${qs ? `?${qs}` : ''}`;
}

export function severityColor(severity) {
  if (severity === 'critical') return 'error';
  if (severity === 'high') return 'warning';
  if (severity === 'moderate') return 'info';
  return 'success';
}

export function formatPrice(currency, value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  const amount = Number.isFinite(n) ? n.toFixed(2).replace(/\.00$/, '') : String(value);
  return `${currency || ''} ${amount}`.trim();
}

export function stockLabel(statusRow) {
  if (!statusRow) return null;
  const status = String(statusRow.Status || statusRow.status || '').trim();
  if (status) return status;
  const inStock = statusRow['In stock'];
  if (inStock === 1 || inStock === '1' || inStock === true) return 'In stock';
  if (inStock === 0 || inStock === '0' || inStock === false) return 'Out of stock';
  return null;
}

export function visibilityRowLabel(promoRow) {
  if (!promoRow) return null;
  const pos = promoRow.Position ?? promoRow.position;
  const page = promoRow.Page ?? promoRow.page;
  if (pos != null && page != null) return `Row ${Math.ceil(Number(pos) / 6) || '—'} · position ${pos} (page ${page})`;
  if (pos != null) return `Position ${pos}`;
  return promoRow['Promo type'] || null;
}
